.container {
  display: flex;
  justify-content: center;
}

.centeredContent {
  max-width: 500px;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2xl);
}

.mainHeading {
  text-align: center;
}

.mainIcon {
  display: flex;
  justify-content: center;
  margin-top: var(--spacing-2xl);
}

.bulletedList {
  list-style-type: disc;
  list-style-position: inside;
}

.contactLinks {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2xl);
}

.businessHoursAlert {
  margin-bottom: var(--spacing-2xl);
}
